import { BlockItem } from "../../types/block-item.types";
import * as moduleExports from "./_index";

function isBlockItem(x: unknown): x is BlockItem {
    return (
        !!x &&
        typeof x === "object" &&
        "id" in x &&
        "label" in x &&
        "description" in x &&
        "group" in x &&
        "source" in x &&
        "content" in x
    );
}

export const BASIC_MODULES: readonly BlockItem[] = Object.values(moduleExports).filter(isBlockItem).filter((b) => b.source === "basic" && b.group === "Modules");
